import { ChannelType } from 'components/CampaignCreationModal/Types'
import { StartWithMedia } from '../../components/StartWithMedia/StartWithMedia'
import { observer } from 'mobx-react-lite'
import { SubmitStepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { FlowProps, TextValues } from 'components/Wizards/MobileWizards/Types'
import { RefineDetails } from '../../components/RefineDetails/RefineDetails'
import { MultiStepMobileWizard } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/MultiStepMobileWizard'
import { useMobileWizardCreateDoc } from 'components/Wizards/MobileWizards/hooks/useMobileWizardCreateDoc'

type Values = Pick<
  TextValues,
  'filename' | 'project' | 'topic' | 'tone' | 'language' | 'brand_kit_id' | 'selected_images'
> & { showAddMedia?: boolean }

export const FlowD = observer(({ schema, onClose, initialValues, ...props }: FlowProps<ChannelType>) => {
  const {
    meta: { channel, title },
  } = schema

  const { createDoc } = useMobileWizardCreateDoc(channel, {
    navigateToDocOnComplete: true,
    loadingToast: `Generating your ${title}...`,
  })

  const handleSubmitStep = async ({
    values,
    currentStep,
    totalSteps,
    advance,
    clearFields,
  }: SubmitStepProps<Values>) => {
    if (values.showAddMedia && currentStep === 0) {
      clearFields(['showAddMedia'])
      advance()
      return
    }

    if (currentStep === totalSteps - 1) {
      await createDoc(values)
      return
    }

    advance()
  }

  return (
    <MultiStepMobileWizard
      schema={schema}
      onClose={onClose}
      onSubmitStep={handleSubmitStep}
      initialValues={initialValues}
      {...props}
    >
      <RefineDetails submitLabel="Generate Post" />
      <StartWithMedia skipBackgroundRemoval />
    </MultiStepMobileWizard>
  )
})
